import { apiGet, APIURL, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getEChartsTooltipTheme, getHeaderPinButtonHTML, getHeaderPinStateClass, getNoDataHTML, getSymbolDropdown, getTraderSMCardHTML, getWidgetDataURI, isHeaderPinned, normalizeWidgetTheme, setupHeaderPin, toggleWidgetTheme, updateSelectedSymbolInDropdown } from './../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';

export class TraderverseIPODealSizeBubble {
  private container: HTMLElement;
  private config: WidgetConfig;
  private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
  private updateInterval: number | null = null;
  private shadowRoot: ShadowRoot;
  private currentData: any = null;
  private chartInstance: any = null;
  private widgetResizeObserver: ResizeObserver | null = null;

  constructor(config: WidgetConfig) {
    this.config = { ...this.getDefaultConfig(), ...config };
    this.config.theme = normalizeWidgetTheme(this.config.theme);
    this.container = this.resolveContainer(config.container);

    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }
    this.init();

    this.widgetResizeObserver = new ResizeObserver(() => {
      if (this.chartInstance) {
        try {
          this.chartInstance.resize();
        } catch {
          this.updateDisplay();
        }
      }
    });
    setTimeout(() => {
      const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
      if (widget) this.widgetResizeObserver?.observe(widget);
    }, 0);
  }

  private fetchSymbols(): Array<{ value: string; label: string }> {
    return [
      { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
      { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
      { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
      { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
      { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
    ];
  }

  private getDefaultConfig(): Partial<WidgetConfig> {
    const symbols = this.fetchSymbols();
    return {
      headerPinned: true,
      symbol: symbols[0].value,
      theme: 'default-dark',
      width: '100%',
      height: '400px',
      autosize: true
    };
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

  private async init(): Promise<void> {
    this.attachStyles();
    if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;
    this.createWidget();
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    if (widget) widget.classList.add('loading');
    await this.injectChartLibrary();
    this.setupEventListeners();
    await this.setupChart(this.config.symbol!);
    if (widget) widget.classList.remove('loading');
    this.emit('ready', {});
    cancelSelectEvent(this.shadowRoot);
    this.config.onReady?.();
  }

  private createWidget(): void {
    let themeClass = 'defaultDarkMode';
  let dataTheme = 'default-dark';
  
  if (this.config.theme === 'white') {
    themeClass = 'whiteMode';
    dataTheme = 'white';
  } else if (this.config.theme === 'black') {
    themeClass = 'blackMode';
    dataTheme = 'black';
  } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}

    const widgetHtml = `
  <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
          <div class="headTop">
            <h4 class="title market">${this.getTitleIconSvg()} IPO Deal Size Bubble</h4>
            <div class="actionCol">${getHeaderPinButtonHTML(this.config)}
              <div class="item">
                <button class="filters-toggle" type="button"> <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1794 0.950592H1.72077C1.57285 0.950469 1.42802 0.991908 1.30363 1.06995C1.17925 1.14799 1.08058 1.25932 1.01944 1.39061C0.958302 1.5219 0.937286 1.66759 0.958909 1.81023C0.980533 1.95286 1.04388 2.0864 1.14136 2.19484L5.22108 6.73834C5.34378 6.8752 5.41132 7.05084 5.41114 7.23259V10.8881C5.41114 10.9463 5.42504 11.0037 5.45175 11.0558C5.47846 11.1079 5.51725 11.1532 5.56503 11.1881L7.87343 12.8756C7.93059 12.9174 7.99856 12.9428 8.06972 12.9491C8.14088 12.9553 8.21242 12.9421 8.27633 12.911C8.34023 12.8799 8.39398 12.832 8.43154 12.7727C8.46911 12.7135 8.489 12.6452 8.489 12.5756V7.23259C8.48882 7.05084 8.55636 6.8752 8.67906 6.73834L12.7588 2.19409C13.1943 1.70959 12.8403 0.950592 12.1794 0.950592Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg> </button>
              </div>
            </div>
          </div>
          <div class="inBody">

            <div class="optionsRow">
              <div class="item"></div>

              <span></span>
              
              <div class="filtersBox sideBar hidden">
                  <div class="item">
                    <label for="x-axis-select">X-Axis</label>
                    <select id="x-axis-select">
                      <option value="price_per_share">Price Per Share</option>
                      <option value="filing_date" selected>Filing Date</option>
                      <option value="days_until_ipo">Days Until IPO</option>
                    </select>
                  </div>

                  <div class="item">
                    <label for="y-axis-select">Y-Axis</label>
                    <select id="y-axis-select">
                      <option value="total_proceeds">Total Proceeds</option>
                      <option value="market_cap">Market Cap</option>
                      <option value="commission_pct">Commission %</option>
                    </select>
                  </div>

                  <div class="item">
                    <label for="bubble-size-select">Bubble Size</label>
                    <div class="fieldsGroup">
                      <select id="bubble-size-select">
                        <option value="shares_offered">Shares Offered</option>
                        <option value="market_cap">Market Cap</option>
                        <option value="custom">Custom</option>
                      </select>
                      <input id="bubble-custom-mult" type="number" placeholder="multiplier"  value="1" />
                    </div>
                  </div>

                  <div class="item">
                    <label for="color-by-select">Color By</label>
                    <select id="color-by-select">
                      <option value="form">Form</option>
                      <option value="price_range">Price Range</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>

                  <div class="item">
                    <label>Size Threshold</label>
                    <div class="fieldsGroup">
                      <input id="min-deal-input" type="number" placeholder="Min deal size" />
                      <input id="max-deal-input" type="number" placeholder="Max deal size" />
                    </div>
                  </div>
              </div>
            </div>

            <div class="chartDv">
              <div class="chart ipoDealSizeBubbleMain" id="marketRealtimeChart"></div>
            </div>

          </div>
        </div>
    `;
    this.shadowRoot.innerHTML = widgetHtml;
    if (this.config.isSymbolSelectable && !this.config.hideSymbol) {
      const dropdown = getSymbolDropdown((data: any) => this.onSelectChange(data));
      const placeholder = this.shadowRoot.getElementById('symbol-dropdown-placeholder');
      if (placeholder && dropdown) {
        placeholder.replaceWith(dropdown);
      }
    }
  }

  onSelectChange(stock: any) {
    this.changeSymbol(stock.symbol, stock);
  }

  private async attachStyles(): Promise<void> {
    try {
      const styleEl = await getCSSStyles();
      this.shadowRoot.appendChild(styleEl);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private setupEventListeners(): void {
    setupHeaderPin(this.shadowRoot, this.config);
    const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
    dropdown?.addEventListener('change', e => {
      const value = (e.target as HTMLSelectElement).value;
      this.changeSymbol(value);
    });
    if (dropdown && this.config.symbol) dropdown.value = this.config.symbol;

    const ids = ['x-axis-select', 'y-axis-select', 'bubble-size-select', 'color-by-select', 'min-deal-input', 'max-deal-input', 'bubble-custom-mult'];
    ids.forEach(id => {
      const el = this.shadowRoot.getElementById(id) as HTMLInputElement | HTMLSelectElement | null;
      if (!el) return;
      el.addEventListener('change', () => {
        this.setupChart(this.config.symbol);
      });
      if (el instanceof HTMLInputElement && el.type === 'number') {
        el.addEventListener('input', () => this.setupChart(this.config.symbol));
      }
    });

    const filtersBtn = this.shadowRoot.querySelector('.filters-toggle') as HTMLButtonElement | null;
    if (filtersBtn) {
      filtersBtn.addEventListener('click', (e) => {
        try {
          const fb = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
          if (!fb) return;
          fb.classList.toggle('hidden');
        } catch (err) {
          console.warn('Error toggling filters box:', err);
        }
      });
    }
  }

  private async injectChartLibrary(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if ((window as any).echarts) return resolve(true);
      if (this.shadowRoot.querySelector('script[data-chart-lib]')) {
        const script = this.shadowRoot.querySelector('script[data-chart-lib]') as HTMLScriptElement;
        script.onload = () => resolve(true);
      } else {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js';
        script.async = true;
        script.setAttribute('data-chart-lib', 'true');
        this.shadowRoot.appendChild(script);
        script.onload = () => resolve(true);
        script.onerror = () => {
          console.error('Failed to load ECharts library');
          resolve(false);
        };
      }
    });
  }

  private async setupChart(symbol?: string, stockInfo?: any): Promise<void> {
    const getVal = (id: string) => (this.shadowRoot.getElementById(id) as HTMLSelectElement | HTMLInputElement | null)?.value ?? '';
    const minDeal = Number(getVal('min-deal-input')) || 10000000;
    const maxDeal = Number(getVal('max-deal-input')) || 500000000;
    const startDate = '2025-10-01';
    const endDate = '2025-10-31';
    const apiUrl = `${APIURL}/v1/discover/ipo-deal-size?p_start_date=${startDate}&p_end_date=${endDate}&p_min_deal_size=${minDeal}&p_max_deal_size=${maxDeal}`;
    try {
      const resp = await apiGet({
        url: apiUrl,
      });
      if (!resp.ok) throw new Error('API error');
      const apiData = await resp.json();
      const bubbles = (apiData?.data || []).map((item: any) => ({
        symbol: item.symbol,
        date: item.date,
        company: item.company,
        deal_size: item.deal_size ?? item.total_proceeds ?? item.market_cap ?? null,
        market_cap: item.market_cap ?? null,
        commission_pct: item.commission_pct ?? null,
        days_until_ipo: item.days_until_ipo ?? null,
        price_per_share: item.price_per_share ?? null,
        total_proceeds: item.total_proceeds ?? item.deal_size ?? null,
        shares_offered: item.shares ?? item.shares_offered ?? null,
        price_category: item.price_category ?? null,
        price_high: item.price_high ?? null,
        price_low: item.price_low ?? null,
        price_range: item.price_range ?? null,
        status: item.status ?? null,
        exchange: item.exchange ?? null,
        form: item.form ?? null,
        filing_date: item.date ?? null,
        cik: item.cik ?? null,
        url: item.url ?? null,
        x_value: item.price_per_share ?? null,
        y_value: item.total_proceeds ?? item.deal_size ?? null,
        bubble_size: item.shares ?? item.shares_offered ?? null,
        color_category: item.form ?? null
      }));
      this.currentData = { data: { bubbles } };
    } catch (err) {
      this.currentData = { data: { bubbles: [] }, error: err };
      console.error('Failed to fetch IPO deal size data:', err);
    }
    this.updateDisplay();
    this.emit('dataUpdate', this.currentData);
  }

  private updateDisplay(): void {
    const el = this.shadowRoot.querySelector('#marketRealtimeChart') as HTMLElement;

    if (!this.currentData || !(window as any).echarts) {
      el?.removeAttribute('data-testing-id');
      setTimeout(() => this.updateDisplay(), 100);
      return;
    }
    el?.setAttribute('data-testing-id', 'ipo-bubble-loaded');

    this.drawChart();
  }

  private toAxisNumber(value: any): number {
    if (value == null || value === '') return NaN;
    if (typeof value === 'number') return value;
    const asNum = Number(value);
    if (Number.isFinite(asNum)) return asNum;
    const asDate = Date.parse(String(value));
    return Number.isFinite(asDate) ? asDate : NaN;
  }

  private drawChart(): void {
    const echarts = (window as any).echarts;
    const container = this.shadowRoot.querySelector('#marketRealtimeChart') as HTMLElement;
    const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    const chartDv = this.shadowRoot.querySelector('.chartDv') as HTMLElement;
    const textColor = getComputedStyle(widgetBox).getPropertyValue('--charts-text-color').trim();
    const axisLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-axis-color').trim();
    const splitLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-split-line-color').trim();
    const chartHeight = chartDv && typeof chartDv.clientHeight === 'number' ? Math.max(chartDv.clientHeight - 20, 280) : 350;

    if (!container) {
      console.warn('Chart container not found');
      return;
    }

    if (!echarts) {
      console.warn('ECharts not loaded yet, retrying...');
      setTimeout(() => this.drawChart(), 100);
      return;
    }

    if (!this.currentData?.data?.bubbles || this.currentData.data.bubbles.length === 0) {
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      container.innerHTML = getNoDataHTML();
      return;
    }

    const getVal = (id: string) => (this.shadowRoot.getElementById(id) as HTMLSelectElement | HTMLInputElement | null)?.value ?? '';
    const selectedX = getVal('x-axis-select') || 'filing_date';
    const selectedY = getVal('y-axis-select') || 'total_proceeds';
    const selectedBubble = getVal('bubble-size-select') || 'shares_offered';
    const colorBy = getVal('color-by-select') || 'form';
    const minDeal = Number(getVal('min-deal-input')) || 10000000;
    const maxDeal = Number(getVal('max-deal-input')) || 500000000;
    const customMult = Number(getVal('bubble-custom-mult')) || 1;

    const axisMap: Record<string, string> = {
      price_per_share: 'price_per_share',
      filing_date: 'filing_date',
      days_until_ipo: 'days_until_ipo',
      total_proceeds: 'total_proceeds',
      market_cap: 'total_proceeds',
      commission_pct: 'commission_pct'
    };

    const sizeMap: Record<string, string> = {
      shares_offered: 'shares_offered',
      market_cap: 'total_proceeds',
      custom: 'bubble_size'
    };

    const xCol = axisMap[selectedX] || 'filing_date';
    const yCol = axisMap[selectedY] || 'total_proceeds';
    const sizeCol = sizeMap[selectedBubble] || 'shares_offered';

    const rawBubbles = this.currentData.data.bubbles || [];
    const filteredBubbles = rawBubbles.filter((b: any) => {
      const deal = Number(b.total_proceeds ?? b.y_value ?? 0);
      return deal >= minDeal && deal <= maxDeal;
    });

    if (filteredBubbles.length === 0) {
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      container.innerHTML = getNoDataHTML('No data matches the current filters');
      return;
    }

    const sizeValues = filteredBubbles.map((b: any) => {
      const raw = Number(b[sizeCol] ?? b.bubble_size ?? 1);
      return Math.max(1, raw * customMult);
    });
    const minSize = Math.min(...sizeValues);
    const maxSize = Math.max(...sizeValues);

    const colorMapping: Record<string, string> = {
      '424B4': 'rgba(138, 43, 226, 0.75)',
      'S-1/A': 'rgba(34, 197, 94, 0.75)',
      'S-1': 'rgba(59, 130, 246, 0.75)',
      'F-1/A': 'rgba(236, 72, 153, 0.75)',
      'F-1': 'rgba(251, 146, 60, 0.75)',
      'default': 'rgba(168, 85, 247, 0.75)'
    };

    const formatMoney = (v: any) =>
      `$${Number(v ?? 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
    const formatShares = (v: any) =>
      Number(v ?? 0).toLocaleString('en-US', { maximumFractionDigits: 0 });

    const scatterData = filteredBubbles.map((b: any, i: number) => {
      const x = this.toAxisNumber(b[xCol] ?? b.x_value);
      const y = this.toAxisNumber(b[yCol] ?? b.y_value);
      const sizeRatio = maxSize === minSize ? 0.5 : (sizeValues[i] - minSize) / (maxSize - minSize);
      const symbolSize = 12 + sizeRatio * 48;
      const form = b.form || b.color_category || 'default';
      const color = colorBy === 'form'
        ? (colorMapping[form] || colorMapping.default)
        : colorMapping.default;

      return {
        value: [x, y, sizeValues[i]],
        symbolSize,
        bubble: b,
        itemStyle: {
          color,
          opacity: 0.8,
          borderColor: 'rgba(255,255,255,0.35)',
          borderWidth: 1
        }
      };
    }).filter((d: any) => Number.isFinite(d.value[0]) && Number.isFinite(d.value[1]));

    if (scatterData.length === 0) {
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      container.innerHTML = getNoDataHTML('No plottable bubble values');
      return;
    }

    container.style.height = `${chartHeight}px`;
    container.style.width = '100%';
    container.innerHTML = '';

    const existing = echarts.getInstanceByDom(container);
    if (existing) existing.dispose();
    this.chartInstance = echarts.init(container);

    const isDateAxis = xCol === 'filing_date';
    const option = {
      backgroundColor: 'transparent',
      tooltip: {
        trigger: 'item',
        confine: true,
        ...getEChartsTooltipTheme(widgetBox),
        formatter: (params: any) => {
          const b = params?.data?.bubble;
          if (!b) return '';
          return `
            <div style="min-width:160px">
              <div style="font-weight:600;margin-bottom:6px;">${b.symbol || '—'}</div>
              <div>Filing Date: ${b.filing_date || 'N/A'}</div>
              <div>Total Proceeds: ${formatMoney(b.total_proceeds)}</div>
              <div>Shares Offered: ${formatShares(b.shares_offered)}</div>
            </div>
          `;
        }
      },
      grid: { left: 16, right: 16, top: 16, bottom: 28, containLabel: true },
      xAxis: {
        type: 'value',
        scale: true,
        axisLine: { lineStyle: { color: axisLineColor } },
        axisTick: { show: false },
        splitLine: { show: true, lineStyle: { type: 'dotted', color: splitLineColor || axisLineColor } },
        axisLabel: {
          color: textColor,
          formatter: (v: number) => {
            if (isDateAxis) {
              const d = new Date(v);
              return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleDateString();
            }
            return Number(v).toLocaleString('en-US', { maximumFractionDigits: 2 });
          }
        }
      },
      yAxis: {
        type: 'value',
        scale: true,
        axisLine: { lineStyle: { color: axisLineColor } },
        axisTick: { show: false },
        splitLine: { show: true, lineStyle: { type: 'dotted', color: splitLineColor || axisLineColor } },
        axisLabel: {
          color: textColor,
          formatter: (v: number) => Number(v).toLocaleString('en-US', { notation: 'compact', maximumFractionDigits: 1 })
        }
      },
      series: [
        {
          type: 'scatter',
          data: scatterData,
          emphasis: {
            scale: 1.1,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2,
              shadowBlur: 8,
              shadowColor: 'rgba(0,0,0,0.35)'
            }
          }
        }
      ]
    };

    this.chartInstance.setOption(option);
  }

  private changeSymbol(stockId: string, stock: any = null): void {
    changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (stockId: any, stockInfo: any) => this.setupChart(stockId, stockInfo), (type: any, data: any) => this.emit(type, data));
  }

  public on(type: WidgetEventType, handler: WidgetEventHandler): void {
    if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
    this.eventHandlers.get(type)!.push(handler);
  }
  public off(type: WidgetEventType, handler: WidgetEventHandler): void {
    const list = this.eventHandlers.get(type);
    if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
  }
  public setSymbol(symbol: string): void {
    this.changeSymbol(symbol);
    const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
    if (dropdown) dropdown.value = symbol;
  }
  public async getWidgetImage(): Promise<string> {
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    return await getWidgetDataURI(widget);
  }
  
  public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
    if (!this.shadowRoot) return;
  
    this.config.theme = toggleWidgetTheme(
      this.shadowRoot,
      theme
    ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
  
    this.updateDisplay();
  }
  public destroy(): void {
    if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
    if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
    this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
  }
  private emit(type: WidgetEventType, data: any): void {
    const handlers = this.eventHandlers.get(type);
    if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
  }
  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/> <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/> </svg>`;
  }

}

declare global { interface Window { TraderverseIPODealSizeBubble: typeof TraderverseIPODealSizeBubble; } }
if (typeof window !== 'undefined') { window.TraderverseIPODealSizeBubble = TraderverseIPODealSizeBubble; }
